<div class="payment-modal-container">
    <!-- Close Button - Top Right -->
    <button (click)="dialogRef.close()" class="close-button" aria-label="Close modal" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
        </svg>
    </button>

    <!-- Header Section -->
    <div class="modal-header">
        <div class="header-content">
            <div class="header-icon-group">
                <div class="icon-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 12l2 2 4-4m5.5 2A9.5 9.5 0 1112 2.5 9.5 9.5 0 0121.5 12z" />
                    </svg>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-sparkles w-5 h-5 text-yellow-300 animate-pulse"
                    data-lov-id="src/components/PaymentModal.tsx:378:14" data-lov-name="SparklesIcon"
                    data-component-path="src/components/PaymentModal.tsx" data-component-line="378"
                    data-component-file="PaymentModal.tsx" data-component-name="SparklesIcon"
                    data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-yellow-300%20animate-pulse%22%7D">
                    <path
                        d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z">
                    </path>
                    <path d="M20 3v4"></path>
                    <path d="M22 5h-4"></path>
                    <path d="M4 17v2"></path>
                    <path d="M5 18H3"></path>
                </svg>
            </div>
            <h2 class="header-title">{{ 'payment-modal.complete-booking' | translate }}</h2>
        </div>
    </div>

    <!-- Main Content -->
    <div class="modal-content">
        <!-- Payment Method Selection -->
        <section class="content-section">
            <div class="section-header">
                <div class="section-indicator"></div>
                <h3 class="section-title">{{ 'payment-modal.choose-payment-method' | translate }}</h3>
            </div>
            <div class="payment-options">
                <!-- Invoice Option -->
                <div class="payment-option" [ngClass]="{'payment-option-selected': selectedPaymentMethod === 'invoice'}"
                    (click)="onPaymentMethodChange('invoice')">
                    <input type="radio" id="payment-invoice" name="payment-method" value="invoice"
                        [checked]="selectedPaymentMethod === 'invoice'" (change)="onPaymentMethodChange('invoice')"
                        (click)="$event.stopPropagation()" class="payment-radio" />
                    <div class="payment-option-content">
                        <div class="payment-icon"
                            [ngClass]="{'payment-icon-active': selectedPaymentMethod === 'invoice'}">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 12h6m-6 4h6M5 8h14M5 4h14a2 2 0 012 2v14l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2z" />
                            </svg>
                        </div>
                        <div class="payment-option-text">
                            <div class="payment-option-title">{{ 'payment-modal.invoice' | translate }}</div>
                            <div class="payment-option-description">{{ 'payment-modal.invoice-description' | translate
                                }}</div>
                        </div>
                        <svg *ngIf="selectedPaymentMethod === 'invoice'" xmlns="http://www.w3.org/2000/svg"
                            class="payment-check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                            <path d="m9 11 3 3L22 4"></path>
                        </svg>
                    </div>
                </div>

                <!-- Card Option -->
                <div class="payment-option" [ngClass]="{'payment-option-selected': selectedPaymentMethod === 'card'}"
                    (click)="onPaymentMethodChange('card')">
                    <input type="radio" id="payment-card" name="payment-method" value="card"
                        [checked]="selectedPaymentMethod === 'card'" (change)="onPaymentMethodChange('card')"
                        (click)="$event.stopPropagation()" class="payment-radio" />
                    <div class="payment-option-content">
                        <div class="payment-icon" [ngClass]="{'payment-icon-active': selectedPaymentMethod === 'card'}">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 4h16a2 2 0 012 2v4H2V6a2 2 0 012-2zm18 6v8a2 2 0 01-2 2H4a2 2 0 01-2-2v-8h20z" />
                            </svg>
                        </div>
                        <div class="payment-option-text">
                            <div class="payment-option-title">{{ 'payment-modal.card-payment' | translate }}</div>
                            <div class="payment-option-description">{{ 'payment-modal.card-payment-description' |
                                translate }}</div>
                        </div>
                        <svg *ngIf="selectedPaymentMethod === 'card'" xmlns="http://www.w3.org/2000/svg"
                            class="payment-check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                            <path d="m9 11 3 3L22 4"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </section>

        @if(showInvoiceDetails) {
        <!-- Invoice Details Section -->
        <section class="content-section">
            <!-- Company Information Card -->
            <div class="info-card">
                <div class="info-card-header">
                    <div class="info-card-header-content">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-building w-4 h-4 text-white"
                            data-lov-id="src/components/PaymentModal.tsx:435:20" data-lov-name="BuildingIcon"
                            data-component-path="src/components/PaymentModal.tsx" data-component-line="435"
                            data-component-file="PaymentModal.tsx" data-component-name="BuildingIcon"
                            data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-white%22%7D">
                            <rect width="16" height="20" x="4" y="2" rx="2" ry="2"></rect>
                            <path d="M9 22v-4h6v4"></path>
                            <path d="M8 6h.01"></path>
                            <path d="M16 6h.01"></path>
                            <path d="M12 6h.01"></path>
                            <path d="M12 10h.01"></path>
                            <path d="M12 14h.01"></path>
                            <path d="M16 10h.01"></path>
                            <path d="M16 14h.01"></path>
                            <path d="M8 10h.01"></path>
                            <path d="M8 14h.01"></path>
                        </svg>
                        <h3 class="info-card-title">{{ 'payment-modal.company-information' | translate }}</h3>
                    </div>
                </div>

                <div class="info-card-body" [formGroup]="invoiceForm">
                    <div class="form-field">
                        <label class="form-label">{{ 'payment-modal.organization-number' | translate }} <span class="required">*</span></label>
                        <div class="search-input">
                            <input type="text" formControlName="organizationNumber"
                                [placeholder]="'payment-modal.organization-number-placeholder' | translate"
                                class="form-input"
                                [ngClass]="{'form-input-error': shouldShowError('organizationNumber')}" />
                            <button type="button" class="search-btn" (click)="searchOrganization()"
                                [attr.aria-label]="'onboarding.search-tooltip' | translate"
                                [disabled]="isSearchingOrganization">
                                <span *ngIf="isSearchingOrganization" class="btn-loader search-btn-loader"></span>
                                <svg *ngIf="!isSearchingOrganization" xmlns="http://www.w3.org/2000/svg"
                                    class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <path d="m21 21-4.3-4.3"></path>
                                </svg>
                            </button>
                        </div>
                        <div *ngIf="orgSearchError" class="error-message">
                            {{ orgSearchError }}
                        </div>
                        <div *ngIf="searchResults.length > 0" class="search-results">
                            <div *ngFor="let company of searchResults" class="search-result-item"
                                (click)="selectCompanyFromSearch(company)" role="button" tabindex="0"
                                (keydown.enter)="selectCompanyFromSearch(company)">
                                <div class="search-result-info">
                                    <h4>{{ company.companyName | titlecase }}</h4>
                                    <p>{{ company.idNumber }}</p>
                                    <p>{{ company.address }}{{ company.address && company.city ? ', ' : '' }}{{
                                        company.city }}</p>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </div>
                        </div>
                        <div *ngIf="shouldShowError('organizationNumber')" class="error-message">
                            {{ getErrorMessage('organizationNumber') }}
                        </div>
                    </div>

                    <div class="form-field">
                        <label class="form-label">{{ 'payment-modal.reference' | translate }} <span class="required">*</span></label>
                        <input type="text" formControlName="contactPerson"
                            [placeholder]="'payment-modal.reference-placeholder' | translate" class="form-input"
                            [ngClass]="{'form-input-error': shouldShowError('contactPerson')}" />
                        <div *ngIf="shouldShowError('contactPerson')" class="error-message">
                            {{ getErrorMessage('contactPerson') }}
                        </div>
                    </div>

                    <div class="form-field">
                        <label class="form-label form-label-with-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" class="label-icon" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            <span>{{ 'payment-modal.invoice-email' | translate }} <span class="required">*</span></span>
                        </label>
                        <input type="email" formControlName="invoiceEmail"
                            [placeholder]="'payment-modal.invoice-email-placeholder' | translate" class="form-input"
                            [ngClass]="{'form-input-error': shouldShowError('invoiceEmail')}" />
                        <div *ngIf="shouldShowError('invoiceEmail')" class="error-message">
                            {{ getErrorMessage('invoiceEmail') }}
                        </div>
                    </div>

                    <div class="checkbox-field" [ngClass]="{'checkbox-field-selected': eInvoiceChecked}">
                        <input type="checkbox" id="e-invoice" class="checkbox-input" [checked]="eInvoiceChecked"
                            (change)="onEInvoiceChange($event)" />
                        <label for="e-invoice" class="checkbox-label">{{ 'payment-modal.use-e-invoicing' | translate
                            }}</label>
                        <svg *ngIf="eInvoiceChecked" xmlns="http://www.w3.org/2000/svg" class="checkbox-check-icon"
                            width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                            <path d="m9 11 3 3L22 4"></path>
                        </svg>
                    </div>
                </div>
            </div>

            <!-- Invoice Timing Card -->
            <div class="info-card">
                <div class="info-card-header">
                    <div class="info-card-header-content">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-calendar w-4 h-4 text-white"
                            data-lov-id="src/components/PaymentModal.tsx:520:20" data-lov-name="CalendarIcon"
                            data-component-path="src/components/PaymentModal.tsx" data-component-line="520"
                            data-component-file="PaymentModal.tsx" data-component-name="CalendarIcon"
                            data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-white%22%7D">
                            <path d="M8 2v4"></path>
                            <path d="M16 2v4"></path>
                            <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                            <path d="M3 10h18"></path>
                        </svg>
                        <h3 class="info-card-title">{{ 'payment-modal.invoice-timing' | translate }}</h3>
                    </div>
                </div>

                <div class="info-card-body">
                    <div class="radio-field"
                        [ngClass]="{'radio-field-selected': selectedInvoiceTiming === 'immediate'}">
                        <input type="radio" id="invoice-immediate" name="invoice-time" value="immediate"
                            [checked]="selectedInvoiceTiming === 'immediate'"
                            (change)="onInvoiceTimingChange('immediate')" class="radio-input" />
                        <label for="invoice-immediate" class="radio-label">{{ 'payment-modal.immediately-after-shift' |
                            translate
                            }}</label>
                        <svg *ngIf="selectedInvoiceTiming === 'immediate'" xmlns="http://www.w3.org/2000/svg"
                            class="radio-check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                            <path d="m9 11 3 3L22 4"></path>
                        </svg>
                    </div>

                    <div class="radio-field"
                        [ngClass]="{'radio-field-selected': selectedInvoiceTiming === 'next-month'}">
                        <input type="radio" id="invoice-next-month" name="invoice-time" value="next-month"
                            [checked]="selectedInvoiceTiming === 'next-month'"
                            (change)="onInvoiceTimingChange('next-month')" class="radio-input" />
                        <label for="invoice-next-month" class="radio-label">{{ 'payment-modal.beginning-of-next-month' |
                            translate
                            }}</label>
                        <svg *ngIf="selectedInvoiceTiming === 'next-month'" xmlns="http://www.w3.org/2000/svg"
                            class="radio-check-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                            <path d="m9 11 3 3L22 4"></path>
                        </svg>
                    </div>
                </div>
            </div>

            <!-- Payment Terms Info -->
            <div class="info-banner">
                <div class="info-banner-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 12l2 2 4-4m5.5 2A9.5 9.5 0 1112 2.5 9.5 9.5 0 0121.5 12z" />
                    </svg>
                </div>
                <div class="info-banner-content">
                    <p class="info-banner-title">{{ 'payment-modal.payment-terms' | translate }}</p>
                    <p class="info-banner-text">{{ 'payment-modal.payment-terms-days' | translate }}</p>
                </div>
            </div>
        </section>
        }
        <!-- Action Buttons -->
        <div class="action-buttons">
            <button type="button" (click)="dialogRef.close()" class="btn btn-secondary">
                {{ 'buttons.cancel' | translate }}
            </button>
            <button type="button" class="btn btn-primary"
                [disabled]="(showInvoiceDetails && invoiceForm.invalid) || !isOrganisationNumberValidForSubmit || isProcessingCardPayment || isCreatingAssignment"
                (click)="onSubmit()">
                <span *ngIf="!showInvoiceDetails || isProcessingCardPayment || isCreatingAssignment"
                    class="btn-loader"></span>
                {{ (isProcessingCardPayment || isCreatingAssignment) ? ('payment-modal.Behandlar' | translate) :
                (showInvoiceDetails ?
                ('payment-modal.create-booking' | translate) : ('payment-modal.create-booking' | translate)) }}
            </button>
        </div>
    </div>
</div>